import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLinkIcon } from 'lucide-react';
export function ExamplesSection() {
  const examples = [{
    id: 1,
    name: 'Academia Boxeo & MMA',
    description: 'Captación de alumnos y reservas online.',
    image: 'https://cdn.magicpatterns.com/uploads/irwhFZP7QG2GA45EGNaLwY/imagen_mma.png',
    demoUrl: 'https://project-calm-beets-774.magicpatterns.app'
  }, {
    id: 2,
    name: 'Barbería Studio',
    description: 'Reservas de citas y captación de clientes.',
    image: 'https://cdn.magicpatterns.com/uploads/vrV9o8RxvkJd6wthp2dhJ2/imagen_peluqueria_.png',
    demoUrl: 'https://project-perfect-kiwi-683.magicpatterns.app'
  }, {
    id: 3,
    name: 'Estética Microblading',
    description: 'Reservas y presencia profesional online.',
    image: 'https://cdn.magicpatterns.com/uploads/riDARvapW55eLRSy3bhuYb/1.png',
    demoUrl: 'https://project-super-pepper-723.magicpatterns.app'
  }];
  return <section id="ejemplos" className="py-24 bg-dark text-white" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <motion.h2 className="text-3xl md:text-4xl font-bold mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-24">
            Así podría verse la web de tu negocio
          </motion.h2>
          <motion.p className="text-lg text-gray-400 max-w-2xl mx-auto" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-25">
            Webs modernas creadas con inteligencia artificial para negocios
            locales.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-26">
          {examples.map((example, index) => <motion.div key={example.id} className="group bg-white/[0.04] rounded-2xl border border-white/[0.08] hover:border-primary/40 transition-all duration-300 shadow-lg shadow-black/15 overflow-hidden flex flex-col" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} data-id="element-27">
              {/* Image — flush to card edges, aspect 4/5, no white borders */}
              <div className="relative aspect-[4/5] w-full overflow-hidden bg-gray-900" data-id="element-28">
                <img src={example.image} alt={example.name} className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-700" data-id="element-29" />
              </div>

              {/* Content — 16px top spacing from image */}
              <div className="px-4 pt-4 pb-5 flex flex-col flex-1" data-id="element-30">
                <h3 className="text-lg font-bold text-white leading-snug" data-id="element-31">
                  {example.name}
                </h3>
                <p className="text-gray-500 text-sm mt-2 leading-relaxed" data-id="element-32">
                  {example.description}
                </p>
                <a href={example.demoUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 mt-4 self-start px-5 py-2 rounded-full bg-primary/10 text-primary text-sm font-semibold hover:bg-primary/20 transition-colors" data-id="element-33">
                  Ver demo
                  <ExternalLinkIcon className="w-3.5 h-3.5" data-id="element-34" />
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}